<template>
  <el-dialog :close-on-click-modal="false" :visible="viewVisible" :modal-append-to-body='false' @close="$emit('closeView')">
    <el-tabs v-model="viewName">
      <el-tab-pane label="详情信息" name="detailForm">
        <el-form :model="detailForm" ref="detailForm" size="mini" class="detail_form">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="基本信息" name="basicInformation">
              <el-col :span="12">
                <el-form-item label="运营商编号：" :label-width="formLabelWidth" prop="operatorId">
                  <label v-text="detailForm.operatorId"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="运营商名称：" :label-width="formLabelWidth" prop="operatorName">
                  <label v-text="detailForm.operatorName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="箱变名称：" :label-width="formLabelWidth" prop="name">
                  <label v-text="detailForm.name"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="箱变功率(KW)：" :label-width="formLabelWidth" prop="powerLoad">
                  <label v-text="detailForm.powerLoad"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="场站编号：" :label-width="formLabelWidth" prop="stationCode">
                  <label v-text="detailForm.stationCode"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="场站名称：" :label-width="formLabelWidth" prop="stationName">
                  <label v-text="detailForm.stationName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="枪口编号列表：" :label-width="formLabelWidth" prop="gunCode">
                  <label v-text="detailForm.gunCode"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="创建人：" :label-width="formLabelWidth" prop="createName">
                  <label v-text="detailForm.createName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="创建时间：" :label-width="formLabelWidth" prop="creationTime">
                  <label v-text="detailForm.createTime"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
  export default {
    name: "customizeView",
    data(){
      return{
        viewName: 'detailForm',
        activeNames: ['basicInformation', 'bindingInformation', 'dateInformation'],
        formLabelWidth: '150px',
        bindingRateFormRules:{
          serviceBillingRulesIdTemp:[{required: true, message: '请选择费率', trigger: 'blur'}]
        },
      }
    },
    props:{
      viewVisible:{
        type:Boolean,
        required: true
      },
      detailForm: {},
      bindingRateForm: {},
      serviceBillingRulesSelect: {},
      serviceBillingRulesIdTemp: ''
    },
    methods:{
      unbinding(){
        console.log('点击了解绑！')
        this.$emit("unbinding")
      },
      dobinding(){
        console.log('点击了绑定！')
        this.$emit("dobinding",this.$refs["bindingRateForm"])
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/gunBox/customizeView.vue